module.exports = __webpack_public_path__ + "img/bmlogo.bf6e6ac2.png";